module.exports = __webpack_public_path__ + "img/hz_12.f122eef9.jpg";